import { createAsyncThunk } from '@reduxjs/toolkit';

import APIDataProvider, { TApiResponse } from '../../../api/ApiDataProvider';
import { ICourseSubscriptionSession, IStripeCustomerPortalData } from '.';
import { ApiPaths } from '../../../api/APIPaths';
import { TCoursePricingType } from '../CoursesSlice';

export type TSubscribeCourse = {
  courseId: string;
  subscriptionType: TCoursePricingType;
  deviceTimezone?: string;
};

export type TCreateFlexibleStripeSession = {
  planId: string;
  userId?: string;
};

export type TCreateSubscriptionStripeSession = {
  planId: string;
  userId?: string;
};

export type TCreateTopUpCourseSession = {
  courseId: string;
  tutorId: string;
  hours: number;
  discountCode?: string;
  isCustom?: boolean;
};

export type TCreateCourseBundlePaymentSession = {
  courseListData: Array<{
    courseId: string;
    creditHours: number;
  }>;
};

const apiDataProvider = new APIDataProvider();

export const subscribeCourse = createAsyncThunk(
  '/stripeV2/subscribe-course',
  async (data: TSubscribeCourse) => {
    const path = `${ApiPaths.stripe}/subscribe-course`;

    const response = await apiDataProvider.post<
      TApiResponse<{
        subscriptionType: TCoursePricingType;
        session: ICourseSubscriptionSession;
      }>
    >(path, data);

    return response.data;
  }
);

export const getCourseSubscriptionSession = createAsyncThunk(
  '/stripeV2/course-subscription-session/id',
  async (id: string) => {
    const path = `${ApiPaths.stripe}/course-subscription-session/${id}`;

    const response = await apiDataProvider.get<
      TApiResponse<ICourseSubscriptionSession>
    >(path);

    return response.data;
  }
);

export const createFlexibleStripeSession = createAsyncThunk(
  '/stripeV2/flexible-session/create',
  async (data: TCreateFlexibleStripeSession) => {
    const path = `${ApiPaths.stripe}/flexible-session`;

    const response = await apiDataProvider.post<
      TApiResponse<ICourseSubscriptionSession>
    >(path, data);

    return response.data;
  }
);

export const createSubscriptionStripeSession = createAsyncThunk(
  '/stripeV2/subscription-session/create',
  async (data: TCreateSubscriptionStripeSession) => {
    const path = `${ApiPaths.stripe}/subscription-session`;

    const response = await apiDataProvider.post<
      TApiResponse<ICourseSubscriptionSession>
    >(path, data);

    return response.data;
  }
);

export const getStripeCustomerPortalData = createAsyncThunk(
  '/stripeV2/customer-portal-data/get',
  async () => {
    const path = `${ApiPaths.stripe}/customer-portal-data`;

    const response = await apiDataProvider.get<
      TApiResponse<IStripeCustomerPortalData>
    >(path);

    return response.data;
  }
);

export const createTopUpCourseSession = createAsyncThunk(
  '/stripeV2/top-up-course',
  async (data: TCreateTopUpCourseSession) => {
    const path = `${ApiPaths.stripe}/top-up-course`;

    const response = await apiDataProvider.post<
      TApiResponse<ICourseSubscriptionSession>
    >(path, data);

    return response.data;
  }
);

export const createCourseBundlePaymentSession = createAsyncThunk(
  '/stripeV2/create-course-bundle-payment-session',
  async (data: TCreateCourseBundlePaymentSession) => {
    const path = `${ApiPaths.stripe}/create-course-bundle-payment-session`;

    const response = await apiDataProvider.post<
      TApiResponse<ICourseSubscriptionSession>
    >(path, data);

    return response.data;
  }
);
